export const design = () => {
    function applyPaddingIfMobile() {
        const isMobile = window.matchMedia('(max-width: 768px)').matches;

        const div01 = document.querySelector('.div01');
        const div02 = document.querySelector('.div02');

        if (isMobile && div01 && div02) {
            const div02HeightPx = div02.offsetHeight;

            // Convert px to rem (assuming 10px = 1rem)
            const remValue = div02HeightPx / 10;

            // Set padding-bottom in rem
            div01.style.paddingBottom = `${remValue}rem`;
        } else if (div01) {
            // Reset padding-bottom if not mobile
            div01.style.paddingBottom = '';
        }
    }

    // Call the function right away
    applyPaddingIfMobile();

    // Also update on window resize
    window.addEventListener('resize', applyPaddingIfMobile);

}